import { create } from 'zustand';
import { MailboxesStoreType } from '../../Types/MailboxesStoreTypes';
import MailboxesReducer from '../Reducers/MailboxesReducer';
import { defaultMailboxesStoreData } from '../Data/MailboxesData';

const useMailboxesStore = create<MailboxesStoreType>((set) => ({
	...defaultMailboxesStoreData,
	dispatchMailboxesStoreUpdate: (action) => set((state) => MailboxesReducer(state, action)),
}));

export { useMailboxesStore };
